import { SupportedLangCode } from '../../../config/languages';
import { getBlogArticlePath } from '../blogArticleSeo';

/** Jedinstven slug za sve jezičke verzije ovog blog posta. */
export const BLOG_FIRST_SESSION_SLUG = 'blog/what-to-expect-from-your-first-psychotherapy-session';

export const getFirstSessionBlogPath = (lang: SupportedLangCode): string =>
    getBlogArticlePath(BLOG_FIRST_SESSION_SLUG, lang);
